import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconGoogle: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="google">
    <path
      d="M12.2002 10.1816V14.0544H17.582C17.3457 15.2998 16.6365 16.3544 15.5729 17.0635L18.8183 19.5817C20.7092 17.8363 21.8001 15.2726 21.8001 12.2272C21.8001 11.5181 21.7365 10.8362 21.6183 10.1817L12.2002 10.1816Z"
      fill="#4285F4"
    />
    <path
      d="M6.59587 13.9033L5.8639 14.4636L3.27295 16.4818C4.9184 19.7454 8.29088 22 12.1999 22C14.8999 22 17.1635 21.1091 18.8181 19.5818L15.5726 17.0636C14.6817 17.6636 13.5453 18.0273 12.1999 18.0273C9.59995 18.0273 7.39093 16.2728 6.59996 13.9091L6.59587 13.9033Z"
      fill="#34A853"
    />
    <path
      d="M3.27284 7.51807C2.59106 8.86347 2.2002 10.3817 2.2002 11.9998C2.2002 13.618 2.59106 15.1362 3.27284 16.4816C3.27284 16.4906 6.60018 13.8998 6.60018 13.8998C6.40018 13.2998 6.28196 12.6634 6.28196 11.9997C6.28196 11.336 6.40018 10.6997 6.60018 10.0997L3.27284 7.51807Z"
      fill="#FBBC05"
    />
    <path
      d="M12.2001 5.98182C13.6729 5.98182 14.982 6.49089 16.0274 7.47273L18.891 4.60913C17.1547 2.99097 14.9002 2 12.2001 2C8.29109 2 4.9184 4.24545 3.27295 7.51819L6.60018 10.1C7.39104 7.73635 9.60016 5.98182 12.2001 5.98182Z"
      fill="#EA4335"
    />
  </Icon>
);
